import React from 'react';
import Icon from '../atoms/Icon';

function BannerIcon (props:any, ref:React.Ref<any>) {
  return (
    <Icon {...props} ref={ref} viewBox="0 0 25 32">
      <path d="M23.3846 29.5385L12.3077 21.2308L1.23077 29.5385V1.23077H23.3846V29.5385Z" fill="#69BD28"/>
      <path d="M24.6154 0V32L12.3077 22.768L0 32V0H24.6154ZM2.46154 27.0769L12.3077 19.6923L22.1538 27.0769V2.46154H2.46154V27.0769Z" fill="#070A13"/>
    </Icon>
  );
}

export default React.forwardRef(BannerIcon);
